import UserInfoContract from "./userInfoContract";
import UserInfo from "../../../checkout/components/billingData/UserInfo";

/**
 * @constructor
 */
function InvoiceDataContract(type) {
    /**
     * @type {string}
     */
    this.type = type || UserInfo.types.NATURAL_PERSON;

    /**
     * @type {UserInfoContract}
     */
    this.userInfo = new UserInfoContract();
}

export default InvoiceDataContract;